import { Icon, Tooltip } from '@mui/material';
import { CheckCircle, Error, Info, Pending, DoDisturbAlt, Help } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { usePostDatahubIntegrationAccountRetryMutation } from '../../../api/datahub-integration/datahubIntegrationApiSlice';
import { useTranslation } from 'react-i18next';

const DatahubIntegrationAccountStatus = ({ datahubIntegrationAccount }) => {

    const {t} = useTranslation('datahub-integration')
    const { ImplementationStatus, IsAuthorized } = datahubIntegrationAccount
    const [postDatahubIntegrationAccountRetry] = usePostDatahubIntegrationAccountRetryMutation()
    const [retry, setRetry] = useState(false)

    useEffect(()=> {
        if (datahubIntegrationAccount.ImplementationStatus.toLowerCase().includes("unavailableerror")) {
            retryPolling(5)
        } else if (!datahubIntegrationAccount.IsAuthorized) {
            retryPolling(1)
        }
    }, [])

    const retryPolling = async (maxRetries) => {
        if (maxRetries <= 0) return
        await postDatahubIntegrationAccountRetry({recalc_account_id: datahubIntegrationAccount.ReCalcAccountId, cvr_number: datahubIntegrationAccount.CustomerCVR}).unwrap().then(response => {
            if (response.ImplementationStatus.toLowerCase().includes("unavailableerror")) {
                setTimeout(() => retryPolling(maxRetries-1), 5000)
            }
        }).catch(response => {
        })
    }

    const createContent = () => {
        let icon
        let label


        if (ImplementationStatus.toLowerCase().includes("unavailableerror")) {
            icon = <Help fontSize='medium' color={'warning'}/>
            label = t('status.unavailable')

            if (!retry)
            {               
                setRetry(true)
            }

        }
        else if (!IsAuthorized) {
            icon = <DoDisturbAlt fontSize='medium' color={'error'}/>
            label = t('status.missing-access')
        }
        else if (ImplementationStatus.toLowerCase().includes("new")) {

            icon = <Info fontSize='medium' color={'info'}/>
            label = t('status.new')
        }
        else if (ImplementationStatus.toLowerCase().includes("processing")) {

            icon = <Pending fontSize='medium' color={'info'}/>
            label = t('status.processing')
        }
        else if (ImplementationStatus.toLowerCase().includes("active")) {
            icon = <CheckCircle fontSize='medium' color={'success'}/>
            label = t('status.success')
        }
        else if (ImplementationStatus.toLowerCase().includes("manualerror")) {
            icon = <Error fontSize='medium' color={'warning'}/>
            label = t('status.manual-error')
        }
        else {
            icon = <Error fontSize='medium' color={'warning'}/>
            label = t('status.unexpected-error')
        }
        return {icon: icon, label: label}

    }
    
    let {icon, label} = createContent()

    return (<>
        <Tooltip disableInteractive placement='top-start' title={label}>
        <Icon sx={{overflow: 'visible'}}>
                {icon}
        </Icon>
        </Tooltip>
        </>);
};

export default DatahubIntegrationAccountStatus;